import { useContext } from 'react';
import UserContext from './UserContext';

export default function useUser() {
  const { user, userFetchState } = useContext(UserContext);
  return { user, userFetchState };
}
